import { UserSaveRequestDto } from '../dto/request/user-save-request.dto';
import { UserUpdateRequestDto } from '../dto/request/user-update-request.dto';
import { UserResponseDto } from '../dto/response/user-response.dto';
import { BaseContextService } from '../../base-context.service';
import { ContextDto } from '../../context/dto/context.dto';
import { DEFAULT_CONTEXT_ID } from '../../../../utils/UUID';
import { BasicInfo } from '../../../../utils/types/types';

class UserService extends BaseContextService {
  public async fetchUsers(): Promise<UserResponseDto[]> {
    const response = await this.get<UserResponseDto[]>('/user');
    return response.data;
  }

  public async fetchLoggedInUserRoles(): Promise<string[]> {
    const contextResponse = await this.get<ContextDto>('/context');
    const context = contextResponse.data;
    return context.roles.map((role) => {
      return role.name;
    });
  }

  public async fetchLoggedInUserContextIds(): Promise<string[]> {
    const contextResponse = await this.get<ContextDto>('/context');
    const context = contextResponse.data;
    return context.roles
      .map((role) => {
        return role.contextId ?? '';
      })
      .filter((contextId) => contextId !== DEFAULT_CONTEXT_ID);
  }

  public async fetchSoftDeletedUsers(): Promise<UserResponseDto[]> {
    const response = await this.get<UserResponseDto[]>('/user/softdeleted');
    return response.data;
  }

  public async fetchUserById(id: string): Promise<UserResponseDto> {
    const response = await this.get<UserResponseDto>(`/user/${id}`);
    return response.data;
  }

  public async createUser(user: UserSaveRequestDto): Promise<UserResponseDto> {
    const response = await this.post<UserResponseDto>(`/user`, user);
    return response.data;
  }

  public async updateUser(
    id: string,
    user: UserUpdateRequestDto
  ): Promise<UserResponseDto> {
    const response = await this.put<UserResponseDto>(`/user`, user, {
      params: {
        id: id,
      },
    });
    return response.data;
  }

  public async deleteUser(id: string): Promise<void> {
    await this.delete<void>(`/user/${id}`);
  }

  public async fetchRoles(): Promise<BasicInfo[]> {
    const response = await this.get<BasicInfo[]>('/role/base-info');
    return response.data;
  }
}

const userService = new UserService();
export default userService;
